export const doDownload = (url, fileName) => {
	const a = document.createElement('a')
	a.download = fileName
	a.href = url
	document.body.appendChild(a)
	a.click()
	document.body.removeChild(a)
}
